import { Controller } from "stimulus"

/**
 * Asks for confirmation before a submit button submits its form, for forms
 * that opt out of Turbo (so data-turbo-confirm does not apply) in an app that
 * never starts Rails UJS (so data-confirm does not either).
 *
 *   <input type="submit" value="Issue Letter"
 *     data-controller="confirm-submit"
 *     data-confirm-submit-message="Issue the letter?"
 *     data-action="click->confirm-submit#confirm">
 */
export default class extends Controller {
  confirm(event) {
    if (window.confirm(this.data.get("message"))) return

    event.preventDefault()
  }
}
